import { render, staticRenderFns } from "./PerfilFormModal.vue?vue&type=template&id=f23b6cc8&scoped=true"
import script from "./PerfilFormModal.vue?vue&type=script&lang=js"
export * from "./PerfilFormModal.vue?vue&type=script&lang=js"
import style0 from "./PerfilFormModal.vue?vue&type=style&index=0&id=f23b6cc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23b6cc8",
  null
  
)

export default component.exports